import RightRail from '../../libs/gs-component-right-rail';
import React, { RefObject, useState } from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';

import styles from './index.scss';
import PageItemRoutes from './PageItemRoutes';

interface Initial {
  disableOverlay: () => void;
  enableOverlay: () => void;
  previewOnClose: boolean;
  previewAfterSave: () => void;
  closeAfterSave: () => void;
  iframeRef?: RefObject<HTMLIFrameElement>;
}

export const RightRailContext = React.createContext<Initial>({} as Initial);

export const PageItemsRail: React.FC = () => {
  const [overlayEnabled, setOverlayEnabled] = useState<boolean>(true);
  const [previewOnClose, setPreviewOnClose] = useState<boolean>(false);
  const match = useRouteMatch('/gs/dashboard/pages/:pageId/:itemType/:itemId?');

  const history = useHistory();
  const onClose = () => {
    history.push('/gs/dashboard');
  };

  const className = !overlayEnabled ? styles.withModal : '';
  const disableOverlay = () => setOverlayEnabled(false);
  const enableOverlay = () => setOverlayEnabled(true);
  const previewAfterSave = () => setPreviewOnClose(true);
  const closeAfterSave = () => setPreviewOnClose(false);

  return (
    <RightRail
      className={`${styles.pageItemRail} ${className}`}
      overlay={overlayEnabled}
      open={!!match}
      onEscapeKey={onClose}
    >
      <RightRailContext.Provider
        value={{ disableOverlay, enableOverlay, previewOnClose, previewAfterSave, closeAfterSave }}
      >
        <PageItemRoutes />
      </RightRailContext.Provider>
    </RightRail>
  );
};
